enum actionTypes {
  FETCH_SKI_PASSES = "FETCH_SKI_PASSES",
  FETCH_SKI_PASSES_TYPES = "FETCH_SKI_PASSES_TYPES",
}

export default actionTypes;
